import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '..';


const JobsTable = ({jobsData}) => {
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})
      const handleDelete = async(id)=>{
        
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(`${API_URL}/api/jobs/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="Job status delete successfully"){
            window.location.reload();
         }
      
       
      }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
        const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'fullname' },
            { data: 'phone' },
            { data: 'affiliate.business_name' ,
            render: function (data, type, row) {
              // Return HTML string for buttons
              if(data) return data;
              else return 'N/a'
            },},
            
            { data: 'users.name' },
            { data: 'status' },
            user.role == 'owner'? 
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <button class="btn btn-success view-btn" data-id="${row.id}"><i class="ph ph-eye"></i></button>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }:
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
               
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View Job</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit Job</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete Job</a></li>
                </ul>
              </div>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
          history(`/lead-edit/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
        const id = $(this).data('id');
          history(`/lead-view/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className="card basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0">Jobs</h5>
            <div class="col-md-6 text-end">
            <Link className="btn btn-info" to={'/add-lead'}>
              Add New
            </Link>
            </div>
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                <th scope="col">
                  <div className="form-check style-check d-flex align-items-center">
                    
                    <label className="form-check-label">ID</label>
                  </div>
                </th>
                <th scope="col">Customer Name</th>
                <th scope="col">Phone</th>
             
                <th scope="col">Assigned To</th>
                
                <th scope="col">Assigned by</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default JobsTable